import { Organization, PaymentMethods, Table, User } from ".";
import { OrderItem } from "./items";
import { AnonymousUser, Location } from "./user";

export enum OrderStatus {
  DRAFT = "draft",
  REJECTED = "rejected",
  CANCELLED = "cancelled",
  REVIEWING = "reviewing",
  PREPARING = "preparing",
  SENDING = "sending",
  DELIVERED = "delivered",
  PAID = "paid", //TODO: remove paid  from status
  COMPLETED = "completed",
  ARCHIVED = "archived",
}

export interface EmptyOrder {
  // TODO: Try to use the OrderDraft convention
  items: OrderItem[];
  subtotal: number;
  taxes: number;
  areTipsIncluded: boolean;
  tipPercentage: number;
  total: number;
}

export interface Order extends Partial<EmptyOrder> {
  id: string;
  status: OrderStatus;
  organizationId: Organization["id"];
  tableId: Table["id"];
  createdBy?: User["uid"];
  lastUpdatedBy?: string;
  createdAt: number;
  orderedAt?: number;
  completedAt?: number;
  paidBy?: User["uid"];
  paidAt?: number;
  number: number;
  paymentDetails?: {
    method: PaymentMethods;
  };
  deliveryLocation?: Location;
  client: AnonymousUser;
}

export interface ArchivedOrder extends Partial<Order> {
  id: string;
  archivedAt: number;
  archivedBy: User["uid"] | AnonymousUser;
}

export interface CompletedOrder extends Partial<Order> {
  id: string;
  completedAt: number;
  completedBy: User["uid"] | AnonymousUser;
}
